module.exports = __webpack_public_path__ + "static/media/man-boy-in-snow.485620a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/patient-hope/man-boy-in-snow.png
// module id = 377
// module chunks = 0